class AppheaderController {
  constructor($timeout, $filter, $interval, $rootScope) {
    this.name = 'appheader';

    this.$timeout = $timeout;
    this.$rootScope = $rootScope;

    var timer;
    var now = new Date();
    this.currentDay = $filter('date')(now, 'EEE');
    this.currentDate = $filter('date')(now, 'M');
    this.currentMonth = $filter('date')(now, 'd');
    this.ampm_marker = $filter('date')(now, 'a');

    this.currunttime = this.getTime();

    /*************************************************************/
    /*    This block updates the code in real-time                                                       */
    /*************************************************************/

    $interval(() => {
    	console.log("i m coming here in appHeader to get the time");
        var now = new Date();
        this.currentDay = $filter('date')(now, 'EEE');
        this.currentDate = $filter('date')(now, 'M');
        this.currentMonth = $filter('date')(now, 'd');
        this.ampm_marker = $filter('date')(now, 'a');
      	this.currunttime = this.getTime();
        this.$rootScope.currunttime = this.currunttime;
    }, 60000);
  }

getTime() {
	var date = date = new Date();
	var hours = date.getHours();
	var minutes = date.getMinutes();
	var ampm = hours >= 12 ? 'pm' : 'am';
	hours = hours % 12;
	hours = hours ? hours : 12;
	minutes = minutes < 10 ? '0' + minutes : minutes;
	//var strTime = hours + ':' + minutes + ' ' + ampm;
    var strTime = hours + ':' + minutes;
	return strTime;
};
}

AppheaderController.$inject = ['$timeout', '$filter', '$interval', '$rootScope'];

export default AppheaderController;



// WEBPACK FOOTER //
// ./client/app/common/appheader/appheader.controller.js